import { Spacer, Button, colors, Body } from '@spritz-finance/ui'
import styled from 'styled-components'
import { Row } from '../../../../../components/Layout/Row'
import { useConfetti } from '../../../../../utils/useConfetti'
import { SubscriptionAccount } from './create/CreateSubscriptionButton'
import { SubscriptionDetails } from './SubscriptionDetails'
import { SubscriptionData } from './SubscriptionForm'

const InfoWrapper = styled.div`
    padding: 16px;
    border-radius: 10px;
    background: var(--surface-3, ${colors.seaSpray[50]});
`

const DetailContainer = styled.div`
    border: 1px solid var(--text-secondary, ${colors.ltGrey});
    border-radius: 12px;
    padding: 16px;
`

export const Summary = ({
    account,
    data,
    onComplete,
}: {
    account: SubscriptionAccount
    data: SubscriptionData
    onComplete: () => void
}) => {
    useConfetti()
    return (
        <>
            <InfoWrapper>
                <Row align="center">
                    <Body.Med>Your recurring payment is set up!</Body.Med>
                </Row>
            </InfoWrapper>
            <Spacer height={16} />
            <DetailContainer>
                <SubscriptionDetails account={account} data={data} />
            </DetailContainer>
            <Spacer height={32} />
            <Row align="center">
                <Button.CTA onClick={onComplete}>Done</Button.CTA>
            </Row>
            <Spacer height={16} />
        </>
    )
}
